<template>
  <div>
    <Head :title="order.data.id"/>


    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/shofer-mbledhes/dergesat">Dërgesat</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ order.data.id }}
    </h1>

    <danger-flash-message v-if="order.data.is_change" :message="`Kjo dërgesë është ndërrim. Dërgesa e ndërruar: ${order.data.return_id}`"></danger-flash-message>
    <danger-flash-message v-if="order.data.is_cash && order.data.has_product" message="Kjo dërgesë është kthim i mjeteve. Kujdes: Ka produkt për t'u kthyer!"></danger-flash-message>
    <danger-flash-message v-if="order.data.is_cash && !order.data.has_product" message="Kjo dërgesë është kthim i mjeteve."></danger-flash-message>
    <danger-flash-message v-if="order.data.is_cash && order.data.return_id" :message="`Dërgesa për kthim: ${order.data.return_id}`"></danger-flash-message>    <danger-flash-message v-if="order.data.is_recreated" :message="`Kjo dërgesë është rinisje. Pako duhet të gjindet në depo.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.recreated_id" :message="`Kjo dërgesë është rinisur. ID e dërgesës së re është ${order.data.recreated_id}.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.parent_id" :message="`Kjo dërgesë duhet të bashkohet me dërgesën me ID: ${order.data.parent_id}.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.children_count !== 0" :message="`Kjo dërgesë duhet të bashkohet me ${order.data.children_count} dërgesë(a) tjera.`"></danger-flash-message>



    <div class=" bg-white rounded-md shadow overflow-hidden">

      <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 justify-between -mr-6 p-5">

        <div class="flex flex-wrap mb-4">
          <label class="font-bold">Statusi Aktual: &nbsp;</label>
          <p><span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="statusColor">{{order.data.status}}</span></p>
        </div>

        <div class="flex flex-wrap lg:space-y-0">

          <div class="flex flex-wrap items-center">
            <select-input v-model="form.status_id" :error="form.errors.status_id" class="pb-8 pr-6 w-full" label="Ndrysho statusin">
              <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
            </select-input>
          </div>
        </div>
      </div>
    </div>


    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">

        <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">
          <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 p-8">
            <dropdown class="mr-2 w-4 h-4" placement="bottom-end">
              <template #default>
                <icon name="print" class="mr-2 w-4 h-4"></icon>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.pdf',{order: order.data.id})" target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.8x5',{order: order.data.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.10x7',{order: order.data.id})" target="_blank">Printo Stiker 10x7cm</a>
                </div>
              </template>
            </dropdown>
          </div>


        </div>
        <hr>


        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Biznesi</label>
            <p>{{order.data.business_name}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pronari</label>
            <p>{{ order.data.owner_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pika marrëse</label>
            <p>{{ order.data.location }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{ order.data.hr_created_at }}</p>
          </div>
        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Madhësia e pakos</label>
            <p>{{ order.data.package_size }} &nbsp; {{order.data.package_size_description}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pako fragjile</label>
            <p>{{order.data.fragile ? 'Po' : 'Jo'}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Mund te hapet</label>
            <p>{{ order.data.openable ? 'Po' : 'Jo'}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Sasia e produktit</label>
            <p>{{ order.data.quantity }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Produkti</label>
            <p>{{ order.data.product_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pershkrimi</label>
            <p>{{ order.data.product_description }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Çmimi</label>
            <p>{{ order.data.product_price }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Çmimi i postes</label>
            <p>{{order.data.shipping_price}}</p>
          </div>
        </div>

        <hr>
        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Emri & Mbiemri i klientit</label>
            <p>{{ order.data.name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Telefoni</label>
            <p>{{ order.data.phone }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Telefoni (sekondar)</label>
            <p>{{ order.data.second_phone }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Shteti</label>
            <p>{{ order.data.country_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Qyteti</label>
            <p>{{ order.data.city_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-2/4">
            <label class="font-bold">Adresa</label>
            <p>{{order.data.address}}</p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Informata shtese</label>
            <p>{{order.data.additional_info}}</p>
          </div>
        </div>

      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden p-5  w-full lg:w-1/2">
        <h1 class="mb-3 text-xl font-bold">Gjurmimi i dërgesës</h1>

        <div class="flex flex-wrap -mb-8 p-8">
          <order-status-timeline :items="timelineItems"></order-status-timeline>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import SearchFilter from '@/Shared/SearchFilter'
import Icon from '@/Shared/Icon'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileOutput from '@/Shared/FileOutput'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import OrderStatusTimeline from '@/Shared/OrderStatusTimeline'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    OrderStatusTimeline,
    Icon,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    SearchFilter,
    TrashedMessage,
    FileOutput,
    Modal,
    FileInput,
    DangerFlashMessage,
    Dropdown

  },
  layout: Layout,
  props: {
    order: Object,
    orderUpdateLogs: Object,
    orderStatusLogs: Object,
    orderReturnLogs: Object,
    orderChange: Object,
    statuses: Array,
  },
  data(){
    return {
      form: this.$inertia.form({
        status_id: this.order.data.status_id,
      }),
      statusSuccess: this.order.data.status_id === 5,
      statusCancellation: this.order.data.status_id === 7,
      showModal: false,

    }
  },
  methods: {
    updateStatus(newValue){
      let self = this

      this.form.put(route('collecting-driver.orders.update.status',{order: this.order.data.id, status_id: newValue}),{
        onError: function (errors){
          if(!errors.status_comment && !errors.status_comment)
            self.showModal = false
        },
        onSuccess: function(){
          self.showModal = false
          self.statusSuccess = newValue === 5
          self.statusCancellation = newValue === 7
        }
      })

      this.form.status_comment = null
      this.form.status_document = null

    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  watch: {
    'form.status_id'(newValue){
      if(newValue === 6 || newValue === 7){
        this.showModal = true
      } else if(newValue === 5 && this.order.data.is_change){
        this.success()
      } else {
        this.updateStatus(newValue)
      }
    }
  },
  computed: {
    timelineItems(){
      return (this.orderStatusLogs.data.concat(this.orderReturnLogs.data)).sort(function(a,b) {
        return new Date(a.hr_created_at) - new Date(b.hr_created_at)
      });
    },
    statusColor(){
      let color = 'bg-indigo-500'
      if(this.order.data.status_id === 1)
        color = 'bg-yellow-500'

      if(this.order.data.status_id === 3)
        color = 'bg-orange-500'

      if(this.order.data.status_id === 4)
        color = 'bg-indigo-900'

      if(this.order.data.status_id === 5)
        color = 'bg-green-500'

      if(this.order.data.status_id === 6)
        color = 'bg-yellow-700'

      if(this.order.data.status_id === 7)
        color = 'bg-red-500'

      if(this.order.data.status_id === 8)
        color = 'bg-gray-400'

      if(this.order.data.status_id === 9)
        color = 'bg-green-500'

      return color
    }
  },
}
</script>

<style>
</style>
